module.exports = __webpack_public_path__ + "img/contacts.2e05902d.jpg";